"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _GenericPluginGroup = _interopRequireDefault(require("./GenericPluginGroup"));

var _utils = require("../lib/utils");

var memoizedImmutablePush = (0, _utils.memoize)(function (a1, a2) {
  return a1.concat([a2]);
});
var createGroupedButton = (0, _utils.memoize)(function (buttons, buttonText, className) {
  return (0, _createReactClass.default)({
    propTypes: {
      disabled: _propTypes.default.bool,
      editorState: _propTypes.default.object.isRequired,
      onChange: _propTypes.default.func
    },
    getDefaultProps: function getDefaultProps() {
      return {
        disabled: false
      };
    },
    getInitialState: function getInitialState() {
      return {
        open: false
      };
    },
    handlePopoverClose: function handlePopoverClose() {
      this.setState({
        open: false
      });
    },
    renderButtons: function renderButtons() {
      var _this = this;

      return buttons.map(function (Button, index) {
        return _react.default.createElement(Button, Object.assign({
          key: index,
          closePopover: _this.handlePopoverClose
        }, _this.props));
      });
    },
    render: function render() {
      var _this2 = this;

      var disabled = this.props.disabled;
      var open = this.state.open;

      if (!buttons) {
        return null;
      }

      return _react.default.createElement(_UIDropdown.default, {
        buttonText: buttonText,
        buttonUse: "transparent",
        closeOnMenuClick: false,
        disabled: disabled,
        open: open,
        onOpenChange: function onOpenChange(evt) {
          return _this2.setState({
            open: evt.target.value
          });
        }
      }, _react.default.createElement(_UIList.default, {
        className: className
      }, this.renderButtons()));
    }
  });
});

var addGroupedButtons = function addGroupedButtons(WrappingComponent, options) {
  // eslint-disable-next-line react/no-multi-comp
  return (0, _createReactClass.default)({
    propTypes: {
      buttons: _propTypes.default.array.isRequired,
      otherButtons: _propTypes.default.array.isRequired
    },
    focus: function focus() {
      if (this.refs.child.focus) {
        this.refs.child.focus();
      }
    },
    blur: function blur() {
      if (this.refs.child.blur) {
        this.refs.child.blur();
      }
    },
    render: function render() {
      var _this$props = this.props,
          buttons = _this$props.buttons,
          otherButtons = _this$props.otherButtons,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["buttons", "otherButtons"]);
      var buttonText = options.buttonText,
          className = options.className;
      var GroupedButton = createGroupedButton(buttons, buttonText, className);
      var allButtons = memoizedImmutablePush(otherButtons, GroupedButton);
      return _react.default.createElement(WrappingComponent, Object.assign({
        ref: "child",
        buttons: allButtons
      }, otherProps));
    }
  });
};

var _default = function _default(options) {
  for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    plugins[_key - 1] = arguments[_key];
  }

  return (0, _GenericPluginGroup.default)(plugins, Object.assign({
    addGroupedButtons: addGroupedButtons
  }, options));
};

exports.default = _default;
module.exports = exports.default;